import NewInquiry from '@/components/NewInquiry';

export default NewInquiry;
